import React from "react";
import PrivacySettingsTeleCaller from "@views/components/user_privacy_settings/user_privacy_settings_tele_caller";
const UserPrivacySettingsTeleCaller = () => {
  return <PrivacySettingsTeleCaller />;
};
export default UserPrivacySettingsTeleCaller;
